import React from 'react';
import PropTypes from 'prop-types';

import GeneralInfo from '../mapbox-popup-general-info/index';

import '../../../../styles/click-tooltip.scss';

/**
 * Mapbox popup customized for our use case
 * We can modify this component e.g. adding dropdown and checkout
 * button as props to improve reusability
 * @param section string, section name
 * @param row string, row id
 * @param seat string, seats
 * @param price object, price with currency
 * @param dropdown instance, dropdown list
 * @param onclose function, to close tooltip
 * @param checkoutButton instance, checkout button on tooltip
 * Other props can be passed depending on how to use this component
 */
const ClickTooltip = ({
  section = '',
  row = '',
  seat = '',
  price = {},
  dropdown,
  onClose,
  checkoutButton,
  type = 'row',
}) => {
  return (
    <>
      <GeneralInfo
        section={section}
        row={row}
        seat={seat}
        price={price}
        onClose={onClose}
        type={type}
        className="MapboxClickTooltipDesktop__Info"
      />

      {dropdown}

      {checkoutButton}
    </>
  );
};

ClickTooltip.propTypes = {
  /** The section name. */
  section: PropTypes.string.isRequired,

  /** The row id. */
  row: PropTypes.string.isRequired,

  /** The seats. */
  seat: PropTypes.string.isRequired,

  /** The price with currency. */
  price: PropTypes.object.isRequired,

  /** The function to close the tooltip. */
  onClose: PropTypes.func.isRequired,

  /** The dropdown list instance. */
  dropdown: PropTypes.element.isRequired,

  /** The checkout button instance. */
  checkoutButton: PropTypes.element.isRequired,

  /** The type of tooltip. */
  type: PropTypes.string,
};

export default ClickTooltip;
